<template>
	<div>
		<div v-if="!loading">
			<vx-card title="Piqwise facturen" class="mb-5">
				<div class="w-full vx-row">
					<div class="vx-col w-full ">
						<br>
						<label>
							<b>Wat kan deze module?</b><br>
							Deze module zorgt ervoor dat je direct vanuit je piqwise account facturen kan verzenden. Dit werkt zonder dat je daar nog een extern boekhoudpakket
							voor nodig hebt. Je kan er zelfs voor kiezen automatische facturen uit te sturen bij elke bestelling. Er wordt gerekend met 21% btw, we berekenen de btw
							terug vanuit de productprijs en gaan er dus vanuit dat de productprijs incl. 21% btw is. <br>
							<br>
							Let op: Deze module heeft alleen effect op bestelling afkomstig van Bol.
						</label>
					</div>

					<div class="vx-col w-full ">
						<br>
						<label>
							<b>Kosten?</b><br>
							Deze module kost 6,99 euro per maand.
						</label>
					</div>

					<div v-if="!moduleInvoices.active" class="vx-col w-full mt-5">
						<vs-button color="primary" type="filled" @click.native="activateModule">Activeer deze module</vs-button>
						<br>
					</div>
				</div>
			</vx-card>

			<div v-if="moduleInvoices.active">

				<div class="vx-row">
					<div class="vx-col w-full mb-5">
						<vx-card title="Factuur nummering">
							<div class="vx-row w-full">
								<div class="vx-col lg:w-1/3 md:w-1/3 w-full">
									<vs-input label="Facuurnummer voorvoegsel"
											  v-model="moduleInvoices.invoice_number_prefix"></vs-input>
								</div>
								<div class="vx-col sm:w-full lg:w-1/3 md:w-1/3 w-full">
									<vs-input label="Volgende factuurnummer"
											  v-model="moduleInvoices.invoice_number_counter"></vs-input>
								</div>
								<div class="vx-col sm:w-full lg:w-1/3 md:w-1/3 w-full">
									<vs-input label="Voorbeeld"
											  v-model="moduleInvoices.invoice_number_prefix + moduleInvoices.invoice_number_counter" disabled=""></vs-input>
								</div>
							</div>
						</vx-card>
					</div>

					<div class="vx-col sm:w-full lg:w-1/2 md:w-1/2 w-full mb-5">
						<vx-card title="Bedrijfsgegevens">
							<div class="vx-row w-full">
								<div class="vx-col w-full mb-5">
									<vs-input label="Bedrijfsnaam" v-model="moduleInvoices.company_name"></vs-input>
								</div>
								<div class="vx-col w-full mb-5">
									<vs-input label="Adres" v-model="moduleInvoices.company_address"></vs-input>
								</div>
								<div class="vx-col sm:w-full lg:w-1/2 md:w-1/2 w-full mb-5">
									<vs-input label="Postcode" v-model="moduleInvoices.company_postal_code"></vs-input>
								</div>
								<div class="vx-col sm:w-full lg:w-1/2 md:w-1/2 w-full mb-5">
									<vs-input label="Stad" v-model="moduleInvoices.company_city"></vs-input>
								</div>
								<div class="vx-col w-full mb-5">
									<vs-input label="Land" v-model="moduleInvoices.company_country"></vs-input>
								</div>
								<div class="vx-col sm:w-full lg:w-1/2 md:w-1/2 w-full mb-5">
									<vs-input label="Kamer van Koophandel nummer" v-model="moduleInvoices.company_kvk"></vs-input>
								</div>
								<div class="vx-col sm:w-full lg:w-1/2 md:w-1/2 w-full mb-5">
									<vs-input label="Belasting nummer" v-model="moduleInvoices.company_btw"></vs-input>
								</div>
							</div>
						</vx-card>
					</div>

					<div class="vx-col sm:w-full lg:w-1/2 md:w-1/2 w-full mb-5">
						<vx-card title="Automatisch verzenden">
							<div class="vx-row w-full">
								<div class="vx-col w-full mb-2">
									<vs-checkbox v-model="moduleInvoices.auto_send">Factuur automatisch naar klant verzenden?</vs-checkbox>
								</div>
								<div class="vx-col w-full">
									Wanneer deze optie actief is zal na binnenkomst van de bestelling direct dat factuur per email naar de klant worden verzonden. De klant hoeft
									hiervoor dus geen factuurverzoek in te dienen.
								</div>
							</div>
						</vx-card>

						<vx-card title="Automatisch verzenden" class="mt-6">
							<div class="vx-row w-full">
								<div class="vx-col w-full mb-2">
									<vs-input label="Kopie email" v-model="moduleInvoices.invoice_copy_email"></vs-input>
								</div>
								<div class="vx-col w-full mb-3">
									Vul hier een email adres in als je zelf ook een kopie van alle verzonden facturen wilt ontvangen
								</div>

								<div class="vx-col w-full">
									<label class="smallLabel">Extra tekst op factuur</label>
									<vs-textarea label="Kopie email" height="50px" v-model="moduleInvoices.invoice_text"></vs-textarea>
								</div>
							</div>
						</vx-card>
					</div>
					<div class="vx-col w-full mb-5">
						<vx-card title="Factuur uploaden naar Bol" v-if="this.dashboard.modules.webshops.bol">
							<div class="vx-row w-full">
								<div class="vx-col w-full mb-2">
									<vs-checkbox v-model="moduleInvoices.bol_auto_upload_request">Bol factuur aanvragen automatisch afhandelen?</vs-checkbox>
								</div>
								<div class="vx-col w-full">
									Wanneer deze optie actief is controleren wij iedere 5 minuten op nieuwe factuuraanvragen en zorgen ervoor dat direct de factuur geupload wordt naar bol.com.
								</div>
							</div>
						</vx-card>
					</div>
				</div>
			</div>

			<div>
				<vx-card v-if="moduleInvoices.active" class="mb-5">
					<div class="w-full vx-row">
						<div class="vx-col w-full">
							<vs-button color="primary" type="filled" style="width: 100%" @click.native="update">Opslaan</vs-button>
						</div>
					</div>
				</vx-card>
			</div>

			<div>
				<vx-card v-if="moduleInvoices.active" title="Module deactiveren">
					<div class="w-full vx-row">
						<div class="vx-col w-full">
							<vs-button color="danger" type="filled" @click.native="deactivateModule">Deactiveer deze module</vs-button>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
	name: 'module-accounting-invoices',
	data() {
		return {
			loading: true,
			moduleInvoices: {},
		}
	},
	mounted() {
		this.$vs.loading();
		this.init()
	},
	computed: {
		...mapGetters({
			invoices: 'invoices/moduleInvoices',
			dashboard: 'dashboard/dashboard',
		})
	},
	methods: {
		init() {
			this.$store.dispatch('invoices/init').then(res => {
				this.moduleInvoices = {...this.$store.state.invoices.moduleInvoices};
				if (this.moduleInvoices) {
					if (this.moduleInvoices.invoice_number_prefix === null || this.moduleInvoices.invoice_number_prefix === "") {
						this.moduleInvoices.invoice_number_prefix = "INV/"
					}
				}
				this.$vs.loading.close();
				this.loading = false;
			})
		},

		update() {
			this.$vs.loading();
			const updateParams = {
				active: this.moduleInvoices.active,
				auto_send: this.moduleInvoices.auto_send,
				bol_auto_upload: this.moduleInvoices.bol_auto_upload,
				bol_auto_upload_request: this.moduleInvoices.bol_auto_upload_request,
				company_name: this.moduleInvoices.company_name,
				company_address: this.moduleInvoices.company_address,
				company_postal_code: this.moduleInvoices.company_postal_code,
				company_city: this.moduleInvoices.company_city,
				company_country: this.moduleInvoices.company_country,
				company_kvk: this.moduleInvoices.company_kvk,
				company_btw: this.moduleInvoices.company_btw,
				invoice_number_prefix: this.moduleInvoices.invoice_number_prefix,
				invoice_number_counter: this.moduleInvoices.invoice_number_counter,
				invoice_btw_amount: this.moduleInvoices.invoice_btw_amount,
				invoice_copy_email: this.moduleInvoices.invoice_copy_email,
				invoice_text: this.moduleInvoices.invoice_text,
			};

			this.$store.dispatch('invoices/moduleUpdate', updateParams).then(res => {
				this.$vs.notify({
					title: 'Gelukt',
					text: 'Je wijzigingen zijn opgeslagen',
					color: 'success'
				});
				this.$vs.loading.close();
			}).catch(error => {
				this.$vs.loading.close();
				this.$vs.notify({
					title: 'Oops',
					text: 'Je wijzigingen zijn niet opgeslagen, controleer je gegevens en probeer het opnieuw',
					color: 'danger'
				});
			});
		},

		activateModule() {
			this.$store.dispatch('invoices/activate').then(res => {
				this.notifySuccessActivate();
				this.init();
			}).catch(err => {
				this.createNotifyFailed();
			});
		},
		deactivateModule() {
			this.$store.dispatch('invoices/deactivate').then(res => {
				this.notifySuccessDeactivate();
				this.init();
			}).catch(err => {
				this.createNotifyFailed();
			});
		},
		notifySuccessActivate() {
			this.$vs.notify({
				color: 'success',
				title: 'Gelukt',
				text: 'De module is geactiveerd!',
			});
		},
		notifySuccessDeactivate() {
			this.$vs.notify({
				color: 'success',
				title: 'Gelukt',
				text: 'De module is gedeactiveerd!',
			});
		},
	},
}
</script>

<style scoped>
.smallLabel {
	color: rgba(0, 0, 0, .7);
	padding-left: 5px;
	font-family: "Montserrat", Helvetica, Arial, sans-serif;
	font-weight: 400;
	font-size: .85rem;
}

ul {
	list-style-type: disc;
}
</style>
